import { useEffect } from "react";

const useOutsideClick = (refContainer, callback) => {

  const handleClick = e => {
    if (refContainer.current && !refContainer.current.contains(e.target)) {
      callback();
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClick);

    return () => {
      document.removeEventListener("click", handleClick);
    };
  });
};

export default useOutsideClick;